import axios from 'src/utils/axios';

export const GET_TOTAL_BOTS = '@bots/get-total-bots';
export const GET_BOTS = '@bots/get-bots';
export const GET_BOT = '@bots/get-bot';
export const ADD_BOT = '@bots/add-bots';
export const DELETE_BOTS = '@bots/delete-bots';
export const UPDATE_BOT = '@bots/update-bots';
export const SHOW_BOT_ACTIONS = '@bots/show-bots-actions';
export const HIDE_BOT_ACTIONS = '@bots/hide-bots-actions';
export const LOAD_AVAILABLE_STAFF = '@bots/load-available-staff';
export const LOAD_AVAILABLE_STAFF_SUCCESS = '@bots/load-available-staff-success';
export const LOAD_AVAILABLE_STAFF_ERROR = '@bots/load-available-staff-error';

export function updateBotsByWorkspace(botIds, workspaceId) {
  const request = axios.put(`/api/bots/updateBotsToWorkspace`, {
    botIds,
    workspaceId
  });
  return dispatch => {
    console.log(`Update to ${workspaceId}: ${JSON.parse(botIds).join(', ')}`);
    return request.then(() => dispatch(getBots(workspaceId)));
  };
}

export function getTotalBots() {
  const request = axios.get('/api/bots/all');
  return dispatch => {
    return request.then(response =>
      dispatch({
        type: GET_TOTAL_BOTS,
        payload: response.data
      })
    );
  };
}

export function getBots(workspaceId) {
  const request = axios.post('/api/bots/all', { workspaceId });
  return dispatch => {
    return request.then(response =>
      dispatch({
        type: GET_BOTS,
        payload: response.data
      })
    );
  };
}

export function getBot(botId) {
  const request = axios.get(`/api/bots/${botId}`);

  return dispatch => {
    return request.then(response =>
      dispatch({
        type: ADD_BOT,
        payload: response.data
      })
    );
  };
}

export function addBot(bot, workspaceId) {
  const request = axios.post('/api/bots/add', { bot, workspaceId });

  return dispatch => {
    return request.then(response =>
      dispatch({
        type: ADD_BOT,
        payload: response.data
      })
    );
  };
}

export function deleteBots(id) {
  const request = axios.delete(`/api/bots/delete/${id}`);
  return dispatch => {
    return request.then(response => {
      dispatch({
        type: DELETE_BOTS,
        payload: { botId: id }
      });
      return response.data;
    });
  };
}

export function updateBot(bot) {
  return dispatch => {
    return axios.put('/api/bots/update', { bot }).then(response => {
      dispatch({
        type: UPDATE_BOT,
        payload: response.data
      });
      return response.data;
    });
  };
}

export function checkAndUpdateBot(bot) {
  const checkRequest = axios.post('/api/bots/check', { bot });

  return dispatch => {
    return checkRequest.then(checkResponse => {
      const enabled = checkResponse.data.status;
      let nlu_config = bot.nlu_config;
      if (typeof bot.nlu_config === 'string') {
        nlu_config = JSON.parse(bot.nlu_config);
      }
      const newBot = { ...bot, nlu_config: { ...nlu_config, enabled } };
      const putRequest = axios.put('/api/bots/update', { bot: newBot });
      return putRequest.then(response => {
        dispatch({
          type: UPDATE_BOT,
          payload: response.data
        });
      });
    });
  };
}

export function restartBot(botId) {
  const request = axios.get(`/api/server/restart/${botId}`);
  request.then(console.log(`[${botId}] restarting bot`));
}

export function loadAvailableStaff(botId) {
  return dispatch => {
    dispatch({
      type: LOAD_AVAILABLE_STAFF,
      payload: { botId }
    });

    const request = axios.get(`/api/bots/${botId}/workspace-staff`);

    return request
      .then(response => {
        dispatch({
          type: LOAD_AVAILABLE_STAFF_SUCCESS,
          payload: {
            botId,
            staff: response.data.staff
          }
        });
        return response.data.staff;
      })
      .catch(error => {
        dispatch({
          type: LOAD_AVAILABLE_STAFF_ERROR,
          payload: {
            botId,
            error: error.message
          }
        });
        throw error;
      });
  };
}
